export default __webpack_public_path__ + "static/media/notaire.9f353602.svg";